const SEGMENT_STYLES = [
  { key: "newCount", label: "New", className: "bg-slate-400" },
  { key: "oldCount", label: "Old", className: "bg-blue-400" },
  { key: "brokenPromiseCount", label: "BP", className: "bg-red-400" },
  { key: "promiseToPayCount", label: "PTP", className: "bg-amber-400" },
  { key: "doneCount", label: "Done", className: "bg-emerald-400" },
] as const

export function pipelineAriaLabel(values: Record<string, number | undefined>) {
  return SEGMENT_STYLES.map(
    (segment) => `${segment.label.toLowerCase()} ${values[segment.key] ?? 0}`,
  ).join(", ")
}

export function PipelineMiniBar({
  values,
  height = "h-2.5",
}: {
  values: Record<string, number | undefined>
  height?: string
}) {
  const total = SEGMENT_STYLES.reduce((sum, segment) => sum + (values[segment.key] ?? 0), 0)

  return (
    <div className="space-y-1">
      <div
        aria-label={`Pipeline: ${pipelineAriaLabel(values)}`}
        className={`flex overflow-hidden rounded-full bg-slate-100 ${height}`}
        role="img"
      >
        {SEGMENT_STYLES.map((segment) => {
          const count = values[segment.key] ?? 0
          const width = total > 0 ? `${(count / total) * 100}%` : "0%"

          return (
            <span
              key={segment.key}
              className={segment.className}
              style={{ width }}
              title={`${segment.label}: ${count}`}
            />
          )
        })}
      </div>
      <div className="flex items-center justify-between text-[10px] text-slate-500">
        {SEGMENT_STYLES.map((segment) => (
          <span key={segment.key}>{segment.label}</span>
        ))}
      </div>
    </div>
  )
}
